import { render, staticRenderFns } from "./ImageTransferApp.vue?vue&type=template&id=1952885b&scoped=true"
import script from "./ImageTransferApp.vue?vue&type=script&lang=js"
export * from "./ImageTransferApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952885b",
  null
  
)

export default component.exports